import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

interface RootState {
    transition: boolean
    drawer: boolean
}

const store = new Vuex.Store<RootState>({
    state: {
        transition: false,
        drawer: false,
    },
    getters: {
        isTransition: (state) => state.transition,
        isDrawer: (state) => state.drawer,
    },
    mutations: {
        SET_TRANSITION: (state, value: boolean) => state.transition = value,
        SET_DRAWER: (state, value: boolean) => state.drawer = value,
    },
    actions: {
        setTransition({ commit }, value: boolean): void {
            commit('SET_TRANSITION', value)
        },
        setDrawer({ commit }, value: boolean): void {
            commit('SET_DRAWER', value)
        },
    }
})

export default store
